<template>
	<div>
	   <el-row :gutter="20" v-loading="listLoading">					   
			   <el-form ref="form" v-model="CreativeForm"  label-width="80px">			
				  <el-col :span="8">
					 <el-form-item v-if="AdsForm.delivery_range=='DEFAULT'" label="投放位置">
						<el-radio-group   size="small" v-model="CreativeForm.inventory">
						  <el-radio-button label="smart_inventory">优选广告位</el-radio-button>
						  <el-radio-button label="inventory_type">按媒体指定位置</el-radio-button>、
						  <el-radio-button label="scene_inventory">按场景指定位置</el-radio-button>								  
						</el-radio-group>
					  </el-form-item>
					  <el-form-item v-if="(CreativeForm.inventory=='scene_inventory')&&(AdsForm.delivery_range=='DEFAULT')">										
						 <el-radio-group  v-model="CreativeForm.scene_inventory">
						   <el-radio label="VIDEO_SCENE">沉浸式竖版视频场景广告位</el-radio>
						   <el-radio label="FEED_SCENE">信息流场景广告位</el-radio>
						   <el-radio label="TAIL_SCENE">视频后贴和尾帧场景广告位</el-radio>
						  </el-radio-group>
					  </el-form-item>
					   <el-form-item v-if="(CreativeForm.inventory=='inventory_type')&&(AdsForm.delivery_range=='DEFAULT')">										
						 <el-checkbox-group v-model="CreativeForm.inventory_type">
						   <el-checkbox label="INVENTORY_FEED">头条系</el-checkbox>
						   <el-checkbox label="INVENTORY_VIDEO_FEED">西瓜信息流</el-checkbox>
						   <el-checkbox label="INVENTORY_HOTSOON_FEED">火山信息流</el-checkbox>
						   <el-checkbox label="INVENTORY_AWEME_FEED">抖音信息流</el-checkbox>
						   <el-checkbox disabed label="INVENTORY_UNION_SLOT">穿山甲</el-checkbox>
						  </el-checkbox-group>
					  </el-form-item>		  
					 <el-form-item label="创意方式">
						<el-radio-group disabled size="small" v-model="CreativeForm.creative_material_mode">
						  <el-radio-button  label="CUSTOM_ASSEMBLE">自定义创意</el-radio-button>
						  <el-radio-button  label="STATIC_ASSEMBLE">程序化创意</el-radio-button>								  
						</el-radio-group>
					  </el-form-item>
					  <el-form-item v-if="AdsForm.download_type=='EXTERNAL_URL'" label="来源">
					   <el-input size="small" v-model="CreativeForm.source"></el-input>
					  </el-form-item>
					    <h5>素材内容 <span style="float:right;"><el-button size="mini" @click="openModel" type="primary">+添加</el-button></span></h5>
						<div class="my-video-list video_list" style="max-height:400px;border:1px dotted #ebebeb;padding:5px;overflow-y:auto;">
						  <ul style="width: 100%;padding:0px 10px;">
								<li v-for="(o,c) in creativeslist" class="list_item">										 
									  <div class="list_image">
										 <img :src="o.img_url" class="ga-mod-cover" />
									  </div>
									  <div class="title-wrap">
										<div v-if="o.title" class="main ga-title">
										  {{o.title}}
										</div>
										<div style="text-align:right;padding:5px;">
										  <el-dropdown>
												  <span class="el-dropdown-link" style="cursor:pointer;">操作<i class="el-icon-arrow-down el-icon--right"></i></span>
												  <el-dropdown-menu slot="dropdown">
													<el-dropdown-item @click.native="editCreate(c,o)">修改</el-dropdown-item>															
													<el-dropdown-item @click.native="removeCreate(c,o)">删除</el-dropdown-item>
												  </el-dropdown-menu>
										  </el-dropdown>												 
										</div>
									 </div>																	 
								
								</li>
						   </ul>
						</div>
                       
				  </el-col>
				  <el-col :span="8"><div class="grid-content bg-purple">	
					  <el-form-item label="创意标题" v-if="CreativeForm.creative_material_mode=='STATIC_ASSEMBLE'">
					    <el-input type="textarea"  v-model="CreativeForm.title_list_string"></el-input>			
				     </el-form-item>
					 <el-form-item  label="应用名">
					   <el-input size="small"  v-model="CreativeForm.app_name"></el-input>
					 </el-form-item>
					 <el-form-item  label="副标题">
					  <el-input size="small"  v-model="CreativeForm.advanced_creative_title"></el-input>
				    </el-form-item>
					<el-form-item  label="衍生计划">
						<el-radio-group size="small" v-model="CreativeForm.generate_derived_ad">
						  <el-radio-button label="0">不启用</el-radio-button>
						  <el-radio-button label="1">启用</el-radio-button>							  
						</el-radio-group>
					</el-form-item>
					<el-form-item  label="创意展现">
						<el-radio-group size="small" v-model="CreativeForm.creative_display_mode">
						  <el-radio-button label="CREATIVE_DISPLAY_MODE_CTR">优选模式</el-radio-button>
						  <el-radio-button label="CREATIVE_DISPLAY_MODE_RANDOM">轮播模式</el-radio-button>								  
						</el-radio-group>
					</el-form-item>
				  </div></el-col>
				 <el-col :span="8"><div class="grid-content bg-purple">
				   <el-form-item label="创意分类">
					  <el-select filterable v-model="CreativeForm.third_industry_id" size="mini" placeholder="请选择">
						<el-option v-for="item in industrylist" :key="item.value" :label="item.label" :value="item.value"></el-option>
					  </el-select>
					</el-form-item>
					<el-form-item label="创意标签">
					    <el-input type="textarea" placeholder="最多20个标签，每个不超过10个字，请用#分割"  v-model="CreativeForm.ad_keywords"></el-input>					
				    </el-form-item>
					<el-form-item label="试玩素材" v-if="AdsForm.delivery_range=='UNION' && AdsForm.union_video_type=='REWARDED_VIDEO'">
						<el-switch v-model="playableSwitch"></el-switch>																		 
					  </el-form-item>
					  <el-form-item label="选择素材" v-if="playableSwitch && AdsForm.delivery_range=='UNION' && AdsForm.union_video_type=='REWARDED_VIDEO'">
						<el-autocomplete style="width:100%;" class="inline-input" size="small" v-model="CreativeForm.playable_url" @select="handleSelectPlay" :fetch-suggestions="querySearchAsync" placeholder="请输入试玩链接地址">
						 <template slot-scope="{ item }">
							<div class="name" style="color:#537ec5;">{{ item.playable_name }}</div>
							<span class="addr">{{ item.playable_url }}</span>
						  </template>
						</el-autocomplete>										
					</el-form-item>
				 </div></el-col>
			  </el-form>
			   <div class="demo-drawer__footer">
				  <el-button size="small" @click="cancelOpen" >取 消</el-button>
				  <el-button size="small" @click="saveCreative" type="danger">修改保存</el-button>
				</div>
		  </el-row>
		   <el-dialog
		  title="广告素材上传"
		  :visible.sync="materialDialogVisible"
		  :append-to-body="true"
		  width="50%">
		  <div class="materialContain">
			<el-form :model="form"  class="demo-dynamic">
			 <el-form-item v-if="CreativeForm.creative_material_mode=='CUSTOM_ASSEMBLE'"  label="创意标题">
					<el-input size="small"  v-model="form.title"></el-input>
			 </el-form-item>
			<el-form-item label="素材类型">
				<el-radio-group v-model="form.image_mode" size="small">
				  <el-radio-button label="CREATIVE_IMAGE_MODE_VIDEO">横版视频</el-radio-button>
				  <el-radio-button label="CREATIVE_IMAGE_MODE_VIDEO_VERTICAL">竖版视频</el-radio-button>
				  <el-radio-button disabled label="CREATIVE_IMAGE_MODE_SMALL">小图</el-radio-button>
				  <el-radio-button disabled label="CREATIVE_IMAGE_MODE_LARGE">大图</el-radio-button>
				  <el-radio-button disabled label="CREATIVE_IMAGE_MODE_GROUP">组图</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="素材内容">											
				<el-row>
				   <div class="add_avatar" style="margin-right:10px;" v-for="item in selectVideo">
					 <img :src="item.poster_url" class="avatar-uploader-icon">
					 <span class="el-upload-list__item-actions">
						<el-tooltip class="item" effect="dark" content="选择封面图" placement="top">
						   <span class="el-upload-list__item-preview" @click="video_cover(item)"><i class="el-icon-picture-outline"></i></span>
						</el-tooltip>									  
					   <span class="el-upload-list__item-preview" @click="deleteSelVideo(item)"><i class="el-icon-delete"></i></span>
					  </span>
				   </div>
				  <div class="add_avatar" @click="libDialogOpen()">
					 <i class="el-icon-plus avatar-uploader-icon"></i>
				   </div>												   
				</el-row>
				<LibPanel ref="Lib" @func="getSelectVideo"></LibPanel>
			</el-form-item>
			
			<el-form-item>											
				<span>封面选取<label style="color:red;">(*必选)</label></span>
				<el-row>
				   <div v-loading="thumbLoading">
				   <el-radio-group v-model="selectThumb" @change="handleThumb">
					  <div class="add_avatar thumb_list" style="border:none;" v-for="i in thumb_List">
						 <img :src="i.url" class="el-image__inner">
						 <el-radio class="thumb_select" :label="i">&nbsp;</el-radio>
					   </div>
				  </el-radio-group>
				  </div>
				</el-row>
			</el-form-item>											
			</el-form>									   
		  </div>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="materialDialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="materialConfirm">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import { getDefaultDataList,getcreativedetail,getIndustryList,getVideoThumbList,getVideoImageInfo,updateCreativeData } from '../../../../api/api';
	import LibPanel from '../model/lib.vue'
	export default {
		components: {LibPanel},
		props:{
		  AdsForm: {
            type: Object,
			default:{}
		  }
		},
		data() {
			return {				
				CreativeForm:{
				 inventory_type:[]
				},
				listLoading:false,
				playableSwitch:false,
				selectVideo:[],
				thumb_List:[],
				industrylist:[],
				video_id:'',
				form:{},
				playable_list:[],
				thumbLoading:false,
				indexnum:-1,
				selectThumbList:[],
				selectThumb:{},
				materialDialogVisible:false,
				creativeslist:[]
			}
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   }
		},
		methods: {
		  cancelOpen(){
			 this.$emit("cancelAdsEditDrawer")
			},
		 getindustry(){
		    let param = {
			   advertiser_id:this.advertiser_id,
			   type:1
			}
			 getIndustryList(param).then((res) => {
					this.industrylist = res.data
			});
		  },
		  libDialogOpen(){
		   this.$refs['Lib'].openModel()
		  },
		  unique(arr) {
		   var obj = {};
		   return arr.reduce(function(item, next) { 
		     obj[next.id]?'':obj[next.id] = true && item.push(next);
			   return item;
			}, []);
		 },
		  getSelectVideo(data){
		   this.selectVideo =  this.unique(this.selectVideo.concat(data));
		  },
		  deleteSelVideo(item){
		   let index=this.selectVideo.findIndex(function (ele) {
			   return ele.id == item.id
			})
			if(index > -1)this.selectVideo.splice(index,1);
			if( this.video_id==item.id )
			{
			  this.thumb_List = []
			}			
		  },
		  editCreate(index,item){
		    this.selectThumbList =[item]
			this.indexnum =index
			this.form = item
			this.video_id = item.video_id
            let params ={
			   advertiser_id:this.advertiser_id,
			   image_id:item.image_id,
			   video_id:item.video_id
			}			
            getVideoImageInfo(params).then((res) => {
					this.materialDialogVisible = true				
					this.selectVideo = res.data.video_info
                    this.thumb_List = res.data.image_info
                    this.selectThumb = this.thumb_List[0]					
			});			
		  },
		  removeCreate(index,item){
		    this.creativeslist.splice(index,1);
		  },
		  handleInventory(){
		    
		  },
		  openModel(){
			 this.thumb_List =[]
			 this.selectThumbList = []
			 this.selectVideo =[]
			 this.selectThumb ={}
			 this.form ={}
			this.materialDialogVisible = true
			this.indexnum = -1
		  },
		  querySearchAsync(queryString, cb) {
           var restaurants = this.playable_list;
           //var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants; 
           cb(restaurants);
		  },
		  handleSelectPlay(item){
		   this.CreativeForm.playable_url = item.playable_url
		  },
		  createFilter(queryString) {
			return (restaurant) => {
			  //return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			  return true
			};
		  },
		  handleThumb(item){
		   let video_id = this.video_id		   
		   let obj = {
		       video_id:video_id,
			   image_id:item.id,
			   img_url:item.url
		   }
		   let index=this.selectThumbList.findIndex(function (ele) {
			   return ele.video_id == video_id
			})
			if( this.indexnum==-1 )
			{
			  if(index > -1){                
					this.selectThumbList[index] = obj
				}else{
				 this.selectThumbList.push(obj)
				}
			}else{
			  this.selectThumbList =[obj]
			}
		  },
		  video_cover(item){
		   
			let params ={
			   advertiser_id:this.advertiser_id,
			   video_id:item.id,
			   type:1
			}
			this.video_id =item.id 
			this.thumbLoading = true			
			getVideoThumbList(params).then((res) => {
					this.thumbLoading = false				
					this.thumb_List = res.data					
			});
		  },
		  materialConfirm(){
		   
		   let title = ''
		   if( this.CreativeForm.creative_material_mode=='CUSTOM_ASSEMBLE' )
		   {
		      title = this.form.title
			  if( !title )
			  {
			    this.$message.error('请填写创意标题!');
			    return false;
			  }
		   }		   
		   if( !this.form.image_mode )
		   {
		      this.$message.error('请选择素材类型!');
			  return false;
		   }
		   if( this.selectThumbList.length<1 )
		   {
		      this.$message.error('请选择素材内容!');
			  return false;
		   }
		  
		   let image_mode = this.form.image_mode
		   let creative_id = this.form.creative_id || ''
           let result = this.selectThumbList.map(item => {
				item.image_mode = image_mode
				if( title )
				{
				  item.title = title
				  item.creative_id = creative_id
				}				
				return item
			})
			if( this.indexnum>-1 )
			{
			  
			  this.creativeslist[this.indexnum] = result[0]
			}else{
			 this.creativeslist =this.creativeslist.concat(result)
			}		
		   this.materialDialogVisible = false
		  },
		  saveCreative(){
		    let para = {
					type:1,
					advertiser_id: this.advertiser_id,
					ad_id:this.AdsForm.id,
					CreativeForm:this.CreativeForm,
					creativeslist:this.creativeslist
				};
			this.listLoading = true;
			updateCreativeData(para).then((res) => {					
				this.listLoading = false;
				if( res.code==200 )
				{
				  this.$message.success(res.message);					  
				  this.$emit("cancelAdsEditDrawer")
				  this.$emit("updateAds")					  
				}else{
				  this.$message.error(res.message);
				}
			});
		  },
		  getCreative(){			  
			  let para = {
					type:1,
					advertiser_id: this.advertiser_id,
					ad_id:this.AdsForm.id
				};
				this.listLoading = true;
				getcreativedetail(para).then((res) => {					
					this.listLoading = false;
					this.CreativeForm = res.data
					this.creativeslist = res.data.creative_list
					this.playable_list = res.data.playable_list
				});
			}
		},
		mounted() {	
		  this.getindustry()
		}
	}

</script>
<style  lang="scss">
.demo-drawer__footer{text-align:right;margin:10px;}
  ul{list-style:none;}
.list_item{width:44%;display:inline-block;margin-right:10px;margin-bottom:10px;border:1px solid #f7f7f7;}
.video_list .list_item:hover{
 box-shadow: 2px 0 6px rgba(0,21,41,.35);
}
.list_image{padding:5px;cursor:pointer;}
.list_image img{width:100%;height:250px;}
.title-wrap{padding:4px 5px;}
.ga-title{font-size:12px;color: #575e74;max-height: 50px;
white-space: inherit;
width: 100%;
overflow: hidden;
text-overflow: ellipsis;}
.ivu-time{
    display: inline-block;
    color: #808695;
    vertical-align: middle;
    font-size: 13px;
    margin-top: 6px;
}
</style>


// WEBPACK FOOTER //
// creative.vue?348530a6